<template>
  <div class="pay-order">
    <section>
      <h3 class="detail-title">财务信息 {{ paymentInfo.payInfoId }}</h3>
      <ul class="detail-list-box">
        <li class="content-item half">
          <span class="detail-child-title">财务凭证号: </span>
          <span class="detail-child-content">
            <span
              v-if="isEdit && paymentInfo.financeVoucherNumber.length === 0"
              class="detail-value"
            >
              <Input
                v-model.trim="financeVoucherNumber"
                class="fina-credical"
              ></Input>
            </span>
            <span v-else class="detail-value">{{
              paymentInfo.financeVoucherNumber
            }}</span>
          </span>
        </li>
        <li class="content-item half">
          <span class="detail-child-title">付款时间: </span>
          <span
            v-empty="paymentInfo.payTime"
            class="detail-child-content"
          ></span>
        </li>
        <li class="content-item half">
          <span class="detail-child-title">财务实付（原币）: </span>
          <span
            v-empty="paymentInfo.payOrigin"
            class="detail-child-content"
          ></span>
        </li>
        <li class="content-item half">
          <span class="detail-child-title">原币币种: </span>
          <span
            v-empty="paymentInfo.currency"
            class="detail-child-content"
          ></span>
        </li>
        <li class="content-item half">
          <span class="detail-child-title">财务实付（人民币）: </span>
          <span
            v-empty="paymentInfo.payRmb"
            class="detail-child-content"
          ></span>
        </li>
        <li class="content-item half">
          <span class="detail-child-title">本次使用抵扣凭证金额: </span>
          <span
            v-empty="paymentInfo.voucherUsedAmount"
            class="detail-child-content"
          ></span>
        </li>

        <li class="content-item column">
          <span class="detail-child-title">付款账户: </span>
          <span
            v-empty="paymentInfo.payAccount"
            class="detail-child-content"
          ></span>
        </li>
        <li class="content-item column">
          <span class="detail-child-title">付款回单: </span>
          <div class="detail-child-content blue">
            <template v-if="isEdit">
              <div class="payment-eidt-upload">
                <i-upload
                  multiple
                  :before-upload="beforeUploadFile"
                  :show-upload-list="false"
                  :on-success="handleSuccess"
                  :action="'/api'"
                  :default-file-list="fileList"
                  :system-id="system_id"
                  ref="upload"
                >
                  <Button type="primary">
                    <Icon type="ios-cloud-upload-outline"></Icon>
                    上传文件
                  </Button>
                </i-upload>
                <div class="upload-list">
                  <div v-for="(item, index) in fileList">
                    <template v-if="item.status === 'finished'">
                      <a
                        download
                        @click="
                          downloadCredence(
                            item.fileId,
                            item.systemId,
                            item.fileName
                          )
                        "
                        >{{ item.file_name || item.fileName }}</a
                      >
                      <Icon
                        type="ios-trash-outline"
                        size="16"
                        @click.native="handleRemove(index)"
                      ></Icon>
                    </template>
                    <template v-else>
                      <Progress
                        v-if="item.showProgress"
                        :percent="item.percentage"
                        hide-info
                      ></Progress>
                    </template>
                  </div>
                </div>
              </div>
            </template>
            <template v-else>
              <div
                v-if="paymentInfo.payInfoAttachment.length > 0"
                class="review-upload-list"
              >
                <div v-for="(item, index) of paymentInfo.payInfoAttachment">
                  <a
                    download
                    @click="
                      downloadCredence(
                        item.fileId,
                        item.systemId,
                        item.fileName
                      )
                    "
                    >{{ item.fileName }}</a
                  >
                </div>
              </div>
              <span
                v-else
                v-empty="paymentInfo.payInfoAttachment"
                class="detail-value"
              ></span>
            </template>
          </div>
        </li>

        <li class="content-item column">
          <span class="detail-child-title">备注: </span>
          <div class="detail-child-content">
            <span v-if="!isEdit" v-empty="paymentInfo.comment"></span>
            <Input
              v-else
              v-model.trim="comment"
              :maxlength="200"
              type="textarea"
              @on-change="whenInputComment"
            ></Input>
          </div>
        </li>
      </ul>
    </section>

    <section>
      <h3 class="detail-title">供应商信息</h3>
      <ul class="detail-list-box">
        <li class="content-item half">
          <span class="detail-child-title">供应商ID: </span>
          <span
            v-empty="paymentInfo.vendorId"
            class="detail-child-content"
          ></span>
        </li>
        <li class="content-item half">
          <span class="detail-child-title">供应商名称: </span>
          <span
            v-empty="paymentInfo.vendorName"
            class="detail-child-content"
          ></span>
        </li>

        <li class="content-item">
          <span class="detail-child-title">供应商账户: </span>
          <span
            v-empty="paymentInfo.vendorAccount"
            class="detail-child-content"
          ></span>
        </li>
      </ul>
    </section>

    <div class="btn-box">
      <Button v-if="isEdit" class="btn" type="primary" @click="saveAndUpdate">
        保存并更新
      </Button>
    </div>

    <div class="detail">
      <Tabs type="card" value="deduction-detail">
        <TabPane label="抵扣明细" name="deduction-detail">
          <div class="decution-detail">
            <Table
              :columns="deductionColumns"
              :data="paymentInfo.voucherInfo"
            ></Table>
          </div>
        </TabPane>
        <TabPane label="付款明细" name="pay-detail">
          <!-- 正向付款单明细 -->
          <div v-if="paymentDetails.payInfoType == 0" class="detailed">
            <Table :columns="forwardDetailColumns" :data="paymentDetails.list">
            </Table>
          </div>
        </TabPane>
      </Tabs>
    </div>
  </div>
</template>

<script>
// 查看编辑付款单
import Vue from "vue";
import IUpload from "bm-upload";
import Json2Excel from "../../../src/libs/json2excel";
import qs from "qs";
import { ENUM_PayType } from "@/type/enum/index";

export default {
  name: "pay-order",
  components: { IUpload },
  directives: {
    empty: {
      componentUpdated(el, binding, vnode) {
        const { value, expression } = binding;
        let func = (value) => value;
        const itemCosFunc = {
          "paymentInfo.settlementId": (txt) => {
            if (txt.length > 0) {
              if (txt.includes(",")) {
                const arr = txt.split(",");
                for (let j = 0; j < arr.length; j++) {
                  arr[j] = `JS-${arr[j]}`;
                }
                txt = arr.join(",");
              } else {
                txt = `JS-${txt}`;
              }
            }
            return txt;
          },
        };
        func = itemCosFunc[expression] || func;
        el.innerHTML = `${func(value)}`;
      },
    },
  },
  data() {
    return {
      payDetailType: false,
      pageNo: 1,
      pageSize: 10,
      isEdit: true,
      deductionColumns: [
        {
          title: "付款单号",
          key: "payInfoId",
        },
        {
          title: "财务凭证号",
          key: "financeVoucherNumber",
        },
        {
          title: "付款时间",
          key: "payTime",
        },
        {
          title: "抵扣凭证原始金额(原币)",
          key: "voucherOriginAmount",
        },
        {
          title: "币种",
          key: "currency",
        },
        {
          title: "本次使用金额",
          key: "voucherUsedThisTime",
        },
      ],
      opsitDetailColumns: [
        {
          title: "斑马订单号",
          key: "displayOrderId",
        },
        {
          title: "财务应付总额（原币）",
          key: "payOriginTotal",
        },
        {
          title: "财务实付总额（原币）",
          key: "paidOriginTotal",
        },
        {
          title: "财务本次实付（原币）",
          key: "paidOrigin",
        },
        {
          title: "原币币种",
          key: "currency",
        },
        {
          title: "财务本次实付（人民币）",
          key: "paidRmb",
        },
        {
          title: "状态",
          key: "status",
        },
      ],
      forwardDetailColumns: [
        {
          title: "序号",
          key: "rowIndex",
        },
        {
          title: "源单单据",
          key: "type",
        },
        {
          title: "源单类型",
          key: "payType",
          render: (h, params) =>
            h("span", {}, ENUM_PayType[params.row.payType]),
        },
        {
          title: "源单编号",
          key: "applyCode",
        },
        {
          title: "申请付款金额",
          key: "applyAmount",
        },
      ],
      system_id: 0,
      fileList: [],
      payOrderId: "", // 付款单号id
      // 现在获取到的上传凭证列表
      payFileList: [],
      financeVoucherNumber: "", // 财务凭证
      comment: "", // 备注
      fileForm: "",
      ossInfo: {
        fileId: "",
        symstemId: "",
      },
      fileIds: [], // 上传的文件 本地服务器 id
      paymentDetails: {},
      paymentInfo: {
        payInfoId: "",
        vendorId: "",
        vendorName: "",
        settlementId: [],
        payOrigin: "",
        currency: "",
        payRmb: "",
        payTime: "",
        payAccount: "",
        vendorAccount: "",
        financeVoucherNumber: "",
        voucherUsedAmount: "",
        comment: "",
        payInfoAttachment: [],
        voucherInfo: [],
      },
      uploadFileInfo: [
        {
          fileName: "",
          fileId: "",
          systemId: "",
        },
      ],
    };
  },
  watch: {
    $route(to, from) {
      const { id, isEdit } = to.query;
      this.initData(id, isEdit);
    },
  },
  methods: {
    initData(id, isEdit) {
      this.init();

      // 获取路径 是否编辑以及付款单号 id
      this.payOrderId = id;
      this.isEdit = isEdit;
      if (typeof isEdit === "string") {
        this.isEdit = isEdit === "true";
      }
      this.getPaymentInfo(this.payOrderId);
      this.getPaymentDetails(true);
    },
    whenInputComment() {
      if (this.comment.trim().length === 200) {
        this.$Message.warning({ content: "备注信息不能超过200个字" });
      }
    },

    // 获取付款单详情页
    getPaymentInfo(id) {
      this.$Spin.show();
      this.http
        .get(this.apiUrl.getOrderDetail, { payInfoId: id })
        .then((res) => {
          for (const key in res) {
            this.$set(this.paymentInfo, `${key}`, res[key]);
          }
          this.comment = this.paymentInfo.comment;
          this.uploadFileInfo = JSON.parse(
            JSON.stringify(this.paymentInfo.payInfoAttachment)
          );
          this.fileList = JSON.parse(JSON.stringify(this.uploadFileInfo));
          this.fileList.forEach((list) => {
            list.status = "finished";
          });
        })
        .catch((err) => {
          this.$Notice.error({ desc: err });
        })
        .finally(() => {
          this.$Spin.hide();
        });
    },

    // 上传之前获取到 file
    beforeUploadFile(file) {
      this.fileForm = new FormData();
      this.fileForm.append("pic", file);
    },
    set(origin, newData) {
      if (typeof origin === "object") {
        if (Array.isArray(origin)) {
          // For Array
          origin.forEach((item, index) => {
            this.$set(newData, index, item);
            this.set(item, newData[index]);
          });
        } else {
          for (const key in origin) {
            this.$set(newData, key, origin[key]);
            this.set(origin[key], newData[key]);
          }
        }
      }
    },

    // 获取到付款明细
    getPaymentDetails(reset) {
      if (reset) {
        this.pageNo = 1;
        this.pageSize = 10;
      }
      this.http
        .get(this.apiUrl.getPayItemDetail, {
          payInfoId: this.payOrderId,
          page: this.pageNo,
          number: this.pageSize,
        })
        .then((res) => {
          this.set(res, this.paymentDetails);
          if (this.paymentDetails.payInfoType === 0) {
            this.paymentDetails.list.forEach((item, index) => {
              item.rowIndex = index + 1;
            });
          }
        });
    },

    // 移除文件
    handleRemove(index) {
      this.uploadFileInfo.splice(index, 1);
      this.fileList.splice(index, 1);
    },

    // 初始化 column style 初始化 oss
    init() {
      this.initColumnStyle();
      this.initOss();
    },

    // 初始化 oss
    initOss() {
      this.http
        .post(this.apiUrl.initOss, { systemName: "finance" })
        .then((res) => {
          this.system_id = res.system_id || 0;
        });
    },
    handleSuccess(res, file, fileList) {
      let { id, name } = res;
      id = typeof id === "object" ? id.id : id;
      file.fileName = name;
      file.fileId = id;
      file.systemId = this.system_id;
      this.ossInfo.fileId = id;
      this.ossInfo.symstemId = this.symstem_id;
      this.fileList = fileList;
      this.uploadFileInfo.push({
        fileName: name,
        fileId: id,
        systemId: this.system_id,
      });
    },

    // 获取到凭证的 url
    downloadCredence(file_id, system_id, fileName) {
      this.http
        .get(this.apiUrl.getUrl, { file_id, system_id, is_public: 0 })
        .then((res) => {
          window.open(res.url);
        });
    },

    // 页数改变
    pageNoChange(pageNo) {
      this.pageNo = pageNo;
      this.getPaymentDetails();
    },

    // 每页文件大小改变的时候
    pageSizeChange(size) {
      this.pageSize = size;
      this.getPaymentDetails();
    },

    // 初始化表格样式
    initColumnStyle() {
      this.renderColumns(this.deductionColumns, "all", "align", "center");
      this.renderColumns(this.forwardDetailColumns, "all", "align", "center");
      this.renderColumns(this.opsitDetailColumns, "all", "align", "center");
    },
    renderColumns(columns, renderKey, name, content) {
      if (!columns) {
        return;
      }
      const forRender = columns.filter((col) => col.key === renderKey)[0];
      if (renderKey === "all") {
        columns.forEach((col) => {
          this.$set(col, name, content);
        });
      } else if (forRender) {
        forRender[name] = content;
      }
    },

    // 保存并且更新内容 传递的是 通过 uploadFile 传递的 id
    saveAndUpdate() {
      const { financeVoucherNumber } = this;
      const { comment } = this;
      this.http
        .post(
          this.apiUrl.eidtPayOrder,
          qs.stringify({
            payInfoId: Number(this.payOrderId),
            payInfoAttachment: this.uploadFileInfo,
            financeVoucherNumber,
            comment,
          })
        )
        .then((res) => {
          if (typeof res === "boolean" && !res) {
            return;
          }
          this.$Notice.success({ title: "更新成功" });
          this.$router.push({
            name: "payOrder",
            query: { id: this.payOrderId, isEdit: false },
          });
          this.getPaymentInfo(this.payOrderId);
        });
    },
  },
  mounted() {
    const { id, isEdit } = this.$route.query;
    this.initData(id, isEdit);
  },
};
</script>
<style lang="postcss">
@import "../../styles/detail.postcss";
</style>

<style lang="less" scoped>
.btn-box {
  margin: 14px 0;
  text-align: center;
}

.btn {
  width: 200px;
  height: 32px;
  box-sizing: border-box;
}

.ivu-message-notice-content {
  background-color: #fff;
}
.pay-order {
  background: white;
  padding: 10px;
  .ivu-message-notice-content {
    background: #fff;
  }
  .emptyData {
    color: lightgray;
  }
  .detail-label {
    width: 130px;
    text-align: right;
    padding: 10px 12px 10px 0;
  }
  .save-btn {
    margin-left: 130px;
    padding: 10px 12px 10px 10px;
  }
  .review-upload-list {
    padding: 10px 12px 10px 0;
  }
  .pay-details {
    margin: 10px 0;
    font-size: 12px;
    color: #495060;
    .detail-content {
      display: flex;
      justify-content: flex-start;
      margin-right: 10px;
      width: 100%;
      span {
        display: inline-block;
        margin-right: 10px;
      }
      .fina-credical {
        width: 200px;
      }
      .remark {
        display: inline-block;
        width: 100%;
      }
      .detail-value {
        display: inline-block;
        padding: 10px 12px 10px 0;
        flex: 1;
        left: 0;
      }
    }
  }
  .payment-upload {
    display: flex;
    vertical-align: top;
    .ivu-upload {
      display: inline-block;
    }
    .upload-list {
      display: inline-block;
      margin-left: 10px;
    }
  }
  .payment-eidt-upload {
    display: flex;
    vertical-align: top;
    padding: 10px 12px 10px 0;
    .upload-list {
      padding-left: 10px;
    }
  }
  .edit-details {
    vertical-align: top;
    span {
      margin-right: 10px;
    }
    .file-upload {
      display: flex;
      .ivu-upload-list {
        margin-top: 0px;
        margin-left: 10px;
        display: inline-block;
      }
    }
  }
  .detailed {
    .detail-btns {
      text-align: left;
      button {
        display: inline-block;
        margin-right: 10px;
        margin-bottom: 10px;
      }
    }
  }
  .tip {
    height: 27px;
    .order-name {
      display: inline-block;
      border-left: 10px solid #495057;
      padding-left: 10px;
      h2 {
        display: inline-block;
        line-height: 27px;
      }
    }
  }
}
</style>
